import '../src/styles/font-poppins.css';
import './styles/App.scss';
import '../src/styles/variables.scss'
import Router from './Router';
import { MuiFooter } from './app/shared/components/footer/footer';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Show() {

    return (
        <React.Fragment>
            <Router />
            <MuiFooter />
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </React.Fragment>
        
    );
}


export default Show;